import React, { useState, useRef } from "react";
import FormContainer from "../../Components/Forms/FormContainer";
import { Container, Row, Button, Form } from "react-bootstrap";
import axios from "axios";
import { requestOptions } from "../../Utils";
import Input from "../../Components/Forms/Input";
import ReactSelect from "../../Components/Forms/ReactSelect";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import API_CONSTANTS from "../../Redux/constants";
import FormGroup from "./FormGroup.js";
import insertSignUpData from "../../Utils/insertSignUpData.js";

import {
  desiredNumberOfWeeklySessionsOptions,
  highestLevelCompetedAtOptions,
  sportOptions,
  stateList,
  timeofDayOptions,
  tzList,
  weekdayOptions
} from "../../Utils/selectConstants";

const NewSalesRepForm = ({
  firstName,
  lastName,
  email,
  phone,
  address,
  city,
  state,
  dateOfBirth,
  sports,
  timezone,
  weekdays,
  timeofday,
  weeklySessions,
  areaOfStudy,
  fullTimeJob,
  highestLevelCompetedAt,
  schoolTeamCompetedFor,
  handleChange,
  preferredClientType,
  preferredTrainingLevel,
  clientType,
  reset_data
}) => {
  const [validated, setValidated] = useState(false);
  const handleSubmit = (event) => {
    event.preventDefault();
    event.stopPropagation();
    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      // do nothing
      setValidated(true);
    } else {
      setValidated(true);
      insertSignUpData(req_obj, clientType, reset_data);
      setValidated(false);
    }
  };

  const req_obj = {
    is_active: 1,
    first_name: firstName,
    last_name: lastName,
    email: email,
    phone: phone,
    address: address,
    city: city,
    address_state: state.value,
    date_of_birth: dateOfBirth,
    sport_specialty: sports.map((data) => data.value),
    primary_time_zone: timezone.value,
    dow_availability: weekdays.map((data) => data.value),
    tod_availability: timeofday.map((data) => data.value),
    desired_weekly_sessions: weeklySessions.value,
    athlete_team_preference: preferredClientType.map((data) => data.value),
    is_religious: "0",
    client_preference_rank: preferredTrainingLevel.map((data) => data.value),
    eligible_for_sales: 1,
    area_of_study: areaOfStudy,
    full_time_job: fullTimeJob,
    highest_level_of_competition: highestLevelCompetedAt.value,
    school_competed_for: schoolTeamCompetedFor
  };

  return (
    <>
      <Form noValidate validated={validated} onSubmit={handleSubmit}>
        <Row className="mb-3 mt-3">
          <FormGroup
            type="text"
            value={firstName}
            handleChange={handleChange}
            required={true}
            label={"First Name"}
            placeholder={"First Name"}
            error_message={"Please enter your First Name."}
          />
          <FormGroup
            type="text"
            value={lastName}
            handleChange={handleChange}
            required={true}
            label={"Last Name"}
            placeholder={"Last Name"}
            error_message={"Please enter your Last Name."}
          />
          <FormGroup
            type="text"
            value={email}
            handleChange={handleChange}
            required={true}
            label={"Email"}
            placeholder={"Email"}
            error_message={"Please enter your Email address."}
          />
          <FormGroup
            type="text"
            value={phone}
            handleChange={handleChange}
            required={true}
            label={"Phone"}
            placeholder={"Phone"}
            error_message={"Please enter your phone number."}
          />
        </Row>
        <Row className="mb-3 mt-3">
          <FormGroup
            type="text"
            value={address}
            handleChange={handleChange}
            required={true}
            label={"Street Address"}
            placeholder={"Street Address"}
            error_message={"Please enter your street address."}
          />
          <FormGroup
            type="text"
            value={city}
            handleChange={handleChange}
            required={true}
            label={"City/Town"}
            placeholder={"City/Town"}
            error_message={"Please enter your city/town."}
          />
          <FormGroup
            type="select"
            value={state.value}
            handleChange={handleChange}
            required={true}
            selector={"State"}
            label={"State"}
            options={stateList}
            error_message={"Please select a state."}
            defaultVal={"Select a State"}
          />
        </Row>
        <Row className="mb-3 mt-3">
          <FormGroup
            type="date"
            value={dateOfBirth}
            handleChange={handleChange}
            required={true}
            label={"Date of Birth"}
            error_message={"Please enter your date of birth."}
          />
          <FormGroup
            type="text"
            value={areaOfStudy}
            handleChange={handleChange}
            required={true}
            label={"Area of Study/Background"}
            placeholder={"Area of Study/Background"}
            error_message={"Please enter your Area of Study/Background."}
          />
          <FormGroup
            type="text"
            value={fullTimeJob}
            handleChange={handleChange}
            required={false}
            label={"Full-time Job"}
            placeholder={"Full-time Job"}
            error_message={"Please enter your Full Time Job."}
          />
        </Row>
        <Row className="mb-3 mt-3">
          <ReactSelect
            options={sportOptions}
            value={sports}
            isMulti
            placeholder="Sport Specialty"
            handleChange={handleChange}
          />
        </Row>
        <Row className="mb-3 mt-3">
          <FormGroup
            type="select"
            value={highestLevelCompetedAt.value}
            handleChange={handleChange}
            required={true}
            selector={"Highest level competed at?"}
            label={"Highest level competed at?"}
            options={highestLevelCompetedAtOptions}
            error_message={"Please select the Highest level you competed at."}
            defaultVal={"Select the Highest level you competed at."}
          />
          {highestLevelCompetedAt.value !== "High School" ? (
            <FormGroup
              type="text"
              value={schoolTeamCompetedFor}
              handleChange={handleChange}
              label={"What school/team did you compete for?"}
              placeholder={"What school/team did you compete for?"}
              error_message={"Please enter your what school/team you competed for."}
            />
          ) : (
            <div></div>
          )}
        </Row>
        <Row className="mb-3 mt-3">
          <FormGroup
            type="select"
            value={timezone.value}
            handleChange={handleChange}
            required={true}
            selector={"Primary Time Zone"}
            label={"Primary Time Zone"}
            options={tzList}
            error_message={"Please select a Primary Time Zone."}
            defaultVal={"Select a Primary Time Zone."}
          />
          <FormGroup
            type="select"
            value={weeklySessions.value}
            handleChange={handleChange}
            required={true}
            selector={"Desired Number of Weekly Sessions"}
            label={"Desired Number of Weekly Sessions"}
            options={desiredNumberOfWeeklySessionsOptions}
            error_message={"Please select Desired Number of Weekly Sessions."}
            defaultVal={"Select Desired Number of Weekly Sessions."}
          />
          <ReactSelect
            options={weekdayOptions}
            value={weekdays}
            isMulti
            placeholder="Available Days"
            handleChange={handleChange}
          />
          <ReactSelect
            options={timeofDayOptions}
            value={timeofday}
            isMulti
            placeholder="Available Time of Day"
            handleChange={handleChange}
          />
        </Row>
        <Button className="mt-3" type="submit">
          Save
        </Button>
      </Form>
    </>
  );
};

export default NewSalesRepForm;
